export default "__VITE_ASSET__CZ4Fwjnt__"